import { Action } from 'redux';

export const SERVER_RESPONSE_ERROR = 'SERVER_RESPONSE_ERROR';
export const RESET_SERVER_RESPONSE_ERROR = 'RESET_SERVER_RESPONSE_ERROR';

export interface ServerResponseErrorAction extends Action {
  errorMessages: string[];
}

export const serverResponseError = (errorMessages: string[]): ServerResponseErrorAction => ({
  type: SERVER_RESPONSE_ERROR,
  errorMessages
});

export const resetServerResponseError = (): Action => ({
  type: RESET_SERVER_RESPONSE_ERROR
});
